export const pkg_tag = {
  sv: {
    tag: 'sv',
    pkg: 'v_year',
    price: '365',
    originPrice: '',
    channelTag: 'svip'
  },
  // todo 双11修改 channelTag
  gv: {
    tag: 'gv',
    pkg: 'v_year_general',
    price: '159',
    originPrice: '240',
    text: '包年',
    channelTag: 'vip12'
  },

  gv2: {
    tag: 'gv2',
    pkg: 'v_half_year_general',
    price: '89',
    originPrice: '120',
    text: '半年',
    // channelTag: '202111huodong'
    channelTag: 'vip6'
  },
  gv1: {
    tag: 'gv1',
    pkg: 'v_mon_general',
    price: '20',
    originPrice: '',
    text: '包月',
    channelTag: 'vip1'
  },
  // todo 增加gv3tag 双11
  gv3: {
    tag: 'gv3',
    pkg: 'v_mon_general_20211111',
    price: '11',
    originPrice: '仅限开通一次',
    text: '新用户首月',
    channelTag: 'vip11'
  }
}
